(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["latest-arrivals"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialize = (root = document) => {
    root.querySelectorAll('[data-latest-arrivals]').forEach(section => {
      if (section.dataset.dropsReady === 'true') return;
      section.dataset.dropsReady = 'true';
      const button = section.querySelector('[data-latest-expand]');
      if (button) {
        button.hidden = false;
        button.addEventListener('click', () => {
          const expanded = section.dataset.expanded !== 'true';
          section.dataset.expanded = String(expanded);
          button.setAttribute('aria-expanded', String(expanded));
          button.querySelector('[data-latest-expand-label]').textContent = expanded ? button.dataset.lessLabel : button.dataset.moreLabel;
        });
      }
      const track = section.querySelector('.latest-arrivals-track');
      const carousel = section.querySelector('.latest-arrivals-carousel');
      const previous = section.querySelector('[data-latest-previous]');
      const next = section.querySelector('[data-latest-next]');
      const cards = [...track.children];
      if (cards.length < 2) return;
      const mobile = matchMedia('(max-width:900px)');
      const reduced = matchMedia('(prefers-reduced-motion:reduce)');
      let cycle = 0, origin = 0, step = 0, timer = null, frame = null, active = false, pointerActive = false, drag = null, blockClickUntil = 0;
      const instant = left => track.scrollTo({left, behavior:'instant'});
      const phaseAt = left => ((left - origin) % cycle + cycle) % cycle;
      const measure = () => {
        if (!active || !track.clientWidth) return;
        const phase = cycle ? phaseAt(track.scrollLeft) / cycle : 0;
        const first = cards[0].getBoundingClientRect();
        const start = track.firstElementChild.getBoundingClientRect();
        step = cards[1].getBoundingClientRect().left - first.left;
        cycle = step * cards.length;
        origin = first.left - start.left;
        if (cycle > 0) instant(origin + phase * cycle);
      };
      const wrap = () => {
        frame = null;
        if (!active || !cycle) return;
        if (track.scrollLeft < cycle || track.scrollLeft > cycle * 3) instant(origin + phaseAt(track.scrollLeft));
      };
      const settle = () => {
        if (!active || pointerActive || !step) return;
        const target = origin + Math.round((track.scrollLeft - origin) / step) * step;
        if (Math.abs(track.scrollLeft - target) > .75) track.scrollTo({left:target, behavior:reduced.matches ? 'instant' : 'smooth'});
      };
      const schedule = () => {clearTimeout(timer); timer = setTimeout(settle, 180);};
      const sync = () => {
        if (active === mobile.matches) return;
        clearTimeout(timer);
        active = mobile.matches;
        pointerActive = false;
        drag = null;
        if (active) {
          const before = document.createDocumentFragment(), after = document.createDocumentFragment();
          const copy = card => {
            const clone = card.cloneNode(true);
            clone.dataset.latestCopy = 'true';
            clone.setAttribute('aria-hidden','true');
            clone.removeAttribute('id');
            clone.querySelectorAll('[id]').forEach(node => node.removeAttribute('id'));
            clone.querySelectorAll('a,button,input,select,textarea,[tabindex]').forEach(node => node.tabIndex = -1);
            return clone;
          };
          for (let group = 0; group < 2; group++) cards.forEach(card => {before.append(copy(card)); after.append(copy(card));});
          track.prepend(before); track.append(after);
          carousel.dataset.loopReady = 'true';
          previous.hidden = false; next.hidden = false;
          cycle = 0; measure();
        } else {
          track.querySelectorAll('[data-latest-copy]').forEach(node => node.remove());
          delete carousel.dataset.loopReady;
          previous.hidden = true; next.hidden = true;
          cycle = 0; instant(0);
        }
      };
      const move = direction => {
        if (!active || !step) return;
        clearTimeout(timer); wrap();
        const target = origin + (Math.round((track.scrollLeft - origin) / step) + direction) * step;
        track.scrollTo({left:target, behavior:reduced.matches ? 'instant' : 'smooth'});
      };
      previous.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
      track.addEventListener('keydown', event => {
        if (!active || !['ArrowLeft','ArrowRight'].includes(event.key)) return;
        event.preventDefault(); move(event.key === 'ArrowRight' ? 1 : -1);
      });
      track.addEventListener('scroll', () => {
        if (!active) return;
        if (frame === null) frame = requestAnimationFrame(wrap);
        schedule();
      }, {passive:true});
      track.addEventListener('pointerdown', event => {
        if (!active) return;
        pointerActive = true; clearTimeout(timer);
        if (event.pointerType === 'mouse' && event.button === 0) drag = {id:event.pointerId, x:event.clientX, y:event.clientY, lastX:event.clientX, moved:false};
      });
      track.addEventListener('pointermove', event => {
        if (!drag || drag.id !== event.pointerId) return;
        if (!drag.moved) {
          const dx = Math.abs(event.clientX - drag.x), dy = Math.abs(event.clientY - drag.y);
          if (dx < 6 || dx <= dy) return;
          drag.moved = true; track.setPointerCapture(event.pointerId);
        }
        event.preventDefault(); instant(track.scrollLeft + drag.lastX - event.clientX); drag.lastX = event.clientX;
      });
      const finish = event => {
        pointerActive = false; schedule();
        if (!drag || drag.id !== event.pointerId) return;
        if (drag.moved) blockClickUntil = performance.now() + 250;
        if (track.hasPointerCapture(event.pointerId)) track.releasePointerCapture(event.pointerId);
        drag = null;
      };
      track.addEventListener('pointerup', finish);
      track.addEventListener('pointercancel', finish);
      track.addEventListener('pointerleave', event => {if (!drag?.moved) finish(event);});
      track.addEventListener('dragstart', event => {if (active) event.preventDefault();});
      track.addEventListener('click', event => {if (performance.now() < blockClickUntil) {event.preventDefault(); event.stopImmediatePropagation();}}, true);
      mobile.addEventListener('change', sync);
      new ResizeObserver(measure).observe(track);
      sync();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());
  else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  document.querySelectorAll('[data-empty-cart-meme]').forEach((meme) => {
    const image = meme.querySelector('[data-empty-cart-meme-image]');
    const toggle = meme.querySelector('[data-empty-cart-meme-toggle]');
    const update = () => {
      toggle.textContent = image.hidden ? toggle.dataset.showLabel : toggle.dataset.hideLabel;
      toggle.setAttribute('aria-expanded', String(!image.hidden));
    };
    image.hidden = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    toggle.hidden = false;
    update();
    toggle.addEventListener('click', () => { image.hidden = !image.hidden; update(); });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["project-shipping-phone-preview"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-shipping-preview]').forEach((root) => {
      if (root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';
      const input = root.querySelector('[data-shipping-input]');
      const verify = root.querySelector('[data-shipping-verify]');
      const status = root.querySelector('[data-shipping-status]');
      const orderResult = root.querySelector('[data-shipping-result="order"]');
      const trackingResult = root.querySelector('[data-shipping-result="tracking"]');
      let timer;

      const reset = () => {
        verify.hidden = true;
        orderResult.hidden = true;
        trackingResult.hidden = true;
      };
      const classify = (value) => {
        const clean = value.trim().replace(/^#/, '');
        if (!clean) return 'empty';
        if (/^\d{4,}$/.test(clean)) return 'order';
        if (/^[A-Z0-9-]{8,}$/i.test(clean) && /[A-Z]/i.test(clean)) return 'tracking';
        return 'invalid';
      };
      const detect = () => {
        reset();
        const kind = classify(input.value);
        if (kind === 'empty') {
          status.textContent = root.dataset.messageReady;
        } else if (kind === 'order') {
          verify.hidden = false;
          status.textContent = root.dataset.messageOrder;
        } else if (kind === 'tracking') {
          trackingResult.hidden = false;
          status.textContent = root.dataset.messageTracking;
        } else {
          status.textContent = root.dataset.messageInvalid;
        }
      };

      input.addEventListener('input', () => {
        window.clearTimeout(timer);
        timer = window.setTimeout(detect, 450);
      });
      root.querySelectorAll('[data-sample]').forEach((button) => {
        button.addEventListener('click', () => {
          input.value = button.dataset.sample;
          detect();
          input.focus();
        });
      });
      verify.addEventListener('submit', (event) => {
        event.preventDefault();
        const contact = verify.querySelector('input');
        if (!contact.value.trim()) {
          contact.focus();
          return;
        }
        verify.hidden = true;
        orderResult.hidden = false;
        status.textContent = root.dataset.messageOrderReady;
        orderResult.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["project-shipping-tracker-drawer"]) return;
  try {
    
  (() => {
    const drawer = document.querySelector('[data-tracker-drawer]');
    if (!drawer || drawer.dataset.initialized === 'true') return;
    drawer.dataset.initialized = 'true';
    const endpoint = drawer.dataset.endpoint;
    const input = drawer.querySelector('[data-shipping-input]');
    const verify = drawer.querySelector('[data-shipping-verify]');
    const status = drawer.querySelector('[data-shipping-status]');
    const result = drawer.querySelector('[data-shipping-result]');
    let timer;
    let opener;
    let identifier = '';
    let accessToken = '';
    let refreshTimer;
    let sequence = 0;

    const copy = (key, values = {}) => Object.entries(values).reduce(
      (value, [name, replacement]) => value.replaceAll(`__${name}__`, String(replacement)),
      drawer.dataset[key] || '',
    );
    const announce = (value, error = false) => {
      status.textContent = value;
      status.dataset.error = String(error);
    };
    const resetResults = (clearToken = true) => {
      verify.hidden = true;
      result.hidden = true;
      result.replaceChildren();
      if (clearToken) accessToken = '';
      window.clearInterval(refreshTimer);
    };
    const classify = (value) => {
      const normalized = value.trim();
      const trackingPrefix = /^(?:(?:ups|usps|fedex|dhl(?:\s+express)?)|tracking(?:\s+(?:number|no\.?))?)(?:\s*[•·:|–—-]\s*|\s+)(?=[A-Z0-9])/i;
      const clean = normalized.replace(/^#/, '');
      const tracking = normalized.replace(trackingPrefix, '').trim();
      const hadTrackingPrefix = tracking !== normalized;
      if (!clean) return 'empty';
      if (/^\d{4,}$/.test(clean)) return 'order';
      if (/^[A-Z0-9 -]{8,}$/i.test(tracking) && /[A-Z]/i.test(tracking)) return 'tracking';
      if (hadTrackingPrefix && /^\d[\d -]{7,}$/.test(tracking)) return 'tracking';
      return 'invalid';
    };
    const request = async (body) => {
      const response = await fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
        credentials: 'same-origin',
        cache: 'no-store',
      });
      let payload;
      try {
        payload = await response.json();
      } catch {
        throw new Error(copy('messageUnavailable'));
      }
      if (!response.ok) throw new Error(payload.message || copy('messageUnavailable'));
      return payload;
    };
    const text = (tag, value, className) => {
      const node = document.createElement(tag);
      node.textContent = value;
      if (className) node.className = className;
      return node;
    };
    const formatDate = (value) => {
      if (!value) return '';
      const date = new Date(value);
      if (Number.isNaN(date.getTime())) return '';
      return new Intl.DateTimeFormat(undefined, { dateStyle: 'medium', timeStyle: 'short' }).format(date);
    };
    const normalizeLabel = (value) => String(value || '').trim().toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
    const timelineGroups = [
      { labels: ['order placed', 'payment confirmed'], label: 'stepOrderReceived', message: 'stepMessageOrderReceived' },
      { labels: ['order processing', 'carefully preparing your order'], label: 'stepPreparing', message: 'stepMessagePreparing' },
      { labels: ['label created'], label: 'stepLabelCreated', message: 'stepMessageLabelCreated' },
      { labels: ['picked up by carrier', 'in transit'], label: 'stepOnTheWay', message: 'stepMessageOnTheWay' },
      { labels: ['out for delivery'], label: 'stepOutForDelivery', message: 'stepMessageOutForDelivery' },
      { labels: ['delivered'], label: 'stepDelivered', message: 'stepMessageDelivered' },
    ];
    const knownTimelineLabels = new Set(timelineGroups.flatMap((group) => group.labels));
    const simplifyTimeline = (timeline) => {
      if (!timeline?.length) return [];
      const hasUnknownCurrentStep = timeline.some((step) => step.state === 'current' && !knownTimelineLabels.has(normalizeLabel(step.label)));
      if (hasUnknownCurrentStep) return timeline;
      const simplified = timelineGroups.map((group) => {
        const matches = timeline.filter((step) => group.labels.includes(normalizeLabel(step.label)));
        if (!matches.length) return null;
        const current = matches.find((step) => step.state === 'current');
        const completed = matches.filter((step) => step.state === 'complete');
        const state = current ? 'current' : completed.length === matches.length ? 'complete' : completed.length ? 'current' : 'upcoming';
        const datedStep = current || [...completed].reverse().find((step) => step.happenedAt);
        return {
          label: copy(group.label),
          message: copy(group.message),
          state,
          happenedAt: datedStep?.happenedAt || '',
        };
      }).filter(Boolean);
      return simplified.length ? simplified : timeline;
    };
    const simplifyCurrentStatus = (data) => {
      const status = normalizeLabel(data.statusLabel);
      const group = timelineGroups.find((candidate) => candidate.labels.includes(status));
      return group
        ? { label: copy(group.label), message: copy(group.message) }
        : { label: data.statusLabel, message: data.statusMessage };
    };
    const renderTimeline = (timeline) => {
      const steps = simplifyTimeline(timeline);
      if (!steps.length) return null;
      const section = document.createElement('section');
      section.className = 'shipping-preview__journey';
      section.setAttribute('aria-label', copy('labelJourney'));
      section.append(text('h4', copy('labelJourney')));
      const list = document.createElement('ol');
      list.className = 'shipping-preview__timeline';
      steps.forEach((step) => {
        const item = document.createElement('li');
        item.className = 'shipping-preview__step';
        item.dataset.state = step.state;
        if (step.state === 'current') item.setAttribute('aria-current', 'step');
        const marker = text('span', step.state === 'complete' ? '✓' : '', 'shipping-preview__marker');
        marker.setAttribute('aria-hidden', 'true');
        const content = document.createElement('div');
        const heading = document.createElement('div');
        heading.className = 'shipping-preview__step-heading';
        heading.append(text('strong', step.label));
        const stateKey = step.state === 'complete' ? 'labelComplete' : step.state === 'current' ? 'labelCurrent' : 'labelUpcoming';
        heading.append(text('span', copy(stateKey), 'shipping-preview__state'));
        content.append(heading, text('p', step.message));
        if (step.happenedAt) {
          const time = text('time', formatDate(step.happenedAt));
          time.dateTime = step.happenedAt;
          content.append(time);
        }
        item.append(marker, content);
        list.append(item);
      });
      section.append(list);
      return section;
    };
    const renderShipment = (shipment, index) => {
      const card = document.createElement('article');
      card.className = 'tracker-drawer__shipment';
      card.append(text('h4', shipment.carrier
        ? copy('labelCarrierPackage', { carrier: shipment.carrier })
        : copy('labelPackage', { index: index + 1 })));
      const meta = document.createElement('div');
      meta.className = 'tracker-drawer__meta';
      if (shipment.trackingNumber) meta.append(text('span', copy('labelTracking', { number: shipment.trackingNumber })));
      if (shipment.estimatedDeliveryAt) meta.append(text('span', copy('labelEstimatedDelivery', { date: formatDate(shipment.estimatedDeliveryAt) })));
      if (shipment.lastCheckedAt) meta.append(text('span', copy('labelLastChecked', { date: formatDate(shipment.lastCheckedAt) })));
      if (meta.childElementCount) card.append(meta);
      if (shipment.carrierUrl) {
        const link = document.createElement('a');
        link.className = 'tracker-drawer__carrier-link';
        link.href = shipment.carrierUrl;
        link.target = '_blank';
        link.rel = 'noopener noreferrer';
        link.textContent = copy('labelCarrierLink');
        card.append(link);
      }
      if (shipment.events?.length) {
        const details = document.createElement('details');
        details.className = 'tracker-drawer__history';
        const summary = document.createElement('summary');
        summary.textContent = copy('labelScanHistory');
        details.append(summary);
        const list = document.createElement('ol');
        shipment.events.forEach((event) => {
          const item = document.createElement('li');
          item.append(text('strong', event.label));
          if (event.happenedAt) item.append(text('div', formatDate(event.happenedAt)));
          list.append(item);
        });
        details.append(list);
        card.append(details);
      }
      return card;
    };
    const render = (payload) => {
      result.replaceChildren();
      const data = payload.order || payload.shipment;
      if (!data) throw new Error(copy('messageUnavailable'));
      const currentStatus = simplifyCurrentStatus(data);
      const current = document.createElement('div');
      current.className = 'tracker-drawer__current';
      current.append(text('p', copy('labelCurrentStatus')));
      current.append(text('h3', currentStatus.label));
      current.append(text('p', currentStatus.message));
      result.append(current);
      if (payload.order) {
        result.append(text('p', copy('labelPackages', {
          delivered: payload.order.deliveredPackageCount,
          total: payload.order.packageCount,
        }), 'tracker-drawer__summary'));
      }
      const timeline = renderTimeline(data.timeline);
      if (timeline) result.append(timeline);
      const shipments = payload.order ? payload.order.shipments : [payload.shipment];
      if (shipments?.length) {
        const list = document.createElement('div');
        list.className = 'tracker-drawer__shipments';
        shipments.forEach((shipment, index) => list.append(renderShipment(shipment, index)));
        result.append(list);
      }
      result.hidden = false;
      announce(copy('messageUpdated'));
      result.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    };
    const showOrderVerification = () => {
      verify.hidden = false;
      announce(copy('messageOrder'));
      verify.querySelector('input').focus();
    };
    const loadTracking = async (requestSequence) => {
      announce(copy('messageTracking'));
      const payload = await request({ operation: 'tracking_status', input: identifier });
      if (requestSequence !== sequence) return;
      render(payload);
    };
    const detect = async () => {
      const requestSequence = ++sequence;
      resetResults();
      const kind = classify(input.value);
      if (kind === 'empty') return announce(copy('messageReady'));
      if (kind === 'invalid') return announce(copy('messageInvalid'), true);
      identifier = input.value.trim();
      announce(copy('messageChecking'));
      try {
        const identified = await request({ operation: 'identify', input: identifier });
        if (requestSequence !== sequence) return;
        if (identified.kind === 'order') showOrderVerification();
        else if (identified.kind === 'tracking') await loadTracking(requestSequence);
        else announce(copy('messageInvalid'), true);
      } catch (error) {
        if (requestSequence === sequence) announce(error instanceof Error ? error.message : copy('messageUnavailable'), true);
      }
    };
    const refresh = async () => {
      if (document.hidden || !drawer.open || !accessToken) return;
      try {
        render(await request({ operation: 'order_status', token: accessToken }));
      } catch (error) {
        announce(error instanceof Error ? error.message : copy('messageUnavailable'), true);
      }
    };
    const scheduleRefresh = () => {
      window.clearInterval(refreshTimer);
      refreshTimer = window.setInterval(refresh, 60_000);
    };
    const open = (source) => {
      opener = source || document.activeElement;
      if (closing) return;
      if (!drawer.open) {
        clearGesture();
        if (!reducedMotion()) drawer.classList.add('is-opening');
        drawer.showModal();
      }
      document.documentElement.classList.add('tracker-drawer-open');
      window.requestAnimationFrame(() => { if (drawer.open) input.focus({ preventScroll: true }); });
    };
    const canReceiveFocus = (element) => Boolean(element?.isConnected && !element.closest('[inert]') && element.getClientRects().length);

    document.querySelectorAll('[data-tracker-open]').forEach((link) => {
      link.addEventListener('click', (event) => {
        event.preventDefault();
        const menu = link.closest('[data-menu]');
        if (menu) {
          menu.classList.remove('is-open');
          document.querySelector('[data-menu-toggle]')?.setAttribute('aria-expanded', 'false');
        }
        open(link);
      });
    });
    input.addEventListener('input', () => {
      window.clearTimeout(timer);
      timer = window.setTimeout(detect, 450);
    });
    verify.addEventListener('submit', async (event) => {
      event.preventDefault();
      const contact = verify.querySelector('input');
      if (!contact.value.trim()) {
        contact.focus();
        return;
      }
      announce(copy('messageVerifying'));
      try {
        const payload = await request({ operation: 'verify_order', input: identifier, contact: contact.value.trim() });
        accessToken = payload.token;
        verify.hidden = true;
        contact.value = '';
        render(payload);
        scheduleRefresh();
      } catch (error) {
        announce(error instanceof Error ? error.message : copy('messageUnavailable'), true);
      }
    });

    let closing = false, gesture = null, blockClickUntil = 0;
    const reducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function clearGesture() {
      if (gesture && drawer.hasPointerCapture(gesture.id)) drawer.releasePointerCapture(gesture.id);
      gesture = null;
      drawer.classList.remove('is-dragging');
      drawer.style.removeProperty('--tracker-drag-x');
    }
    function close() {
      if (!drawer.open || closing) return;
      closing = true;
      drawer.classList.remove('is-opening');
      const finish = () => { drawer.close(); closing = false; };
      if (reducedMotion()) finish();
      else { drawer.classList.add('is-closing'); window.setTimeout(finish,180); }
    }
    drawer.addEventListener('animationend',event => {
      if (event.target === drawer && event.animationName === 'tracker-side-in') drawer.classList.remove('is-opening');
    });
    drawer.addEventListener('pointerdown',event => {
      if (!window.matchMedia('(max-width:749px)').matches || closing || event.isPrimary === false || event.button > 0) return;
      if (event.target.closest('button,input,select,textarea,a') && !event.target.closest('[data-tracker-edge]')) return;
      gesture = { id:event.pointerId, x:event.clientX, y:event.clientY, dx:0, horizontal:false };
    },{passive:true});
    drawer.addEventListener('pointermove',event => {
      if (!gesture || gesture.id !== event.pointerId) return;
      const dx = event.clientX - gesture.x, dy = event.clientY - gesture.y;
      if (!gesture.horizontal) {
        if (Math.max(Math.abs(dx),Math.abs(dy)) < 10) return;
        if (Math.abs(dy) >= Math.abs(dx) || dx < 0) { clearGesture(); return; }
        gesture.horizontal = true;
        drawer.classList.remove('is-opening');
        drawer.setPointerCapture(event.pointerId);
      }
      event.preventDefault();
      blockClickUntil = Date.now()+350;
      gesture.dx = Math.max(0,dx);
      drawer.classList.add('is-dragging');
      drawer.style.setProperty('--tracker-drag-x',gesture.dx+'px');
    },{passive:false});
    drawer.addEventListener('pointerup',event => {
      if (!gesture || gesture.id !== event.pointerId) return;
      const dismiss = gesture.horizontal && gesture.dx >= 72;
      if (drawer.hasPointerCapture(event.pointerId)) drawer.releasePointerCapture(event.pointerId);
      if (dismiss) { gesture = null; close(); } else clearGesture();
    });
    drawer.addEventListener('pointercancel',clearGesture);
    drawer.addEventListener('dragstart',event => { if (gesture) event.preventDefault(); });
    drawer.addEventListener('click',event => { if (Date.now() < blockClickUntil) { event.preventDefault(); event.stopImmediatePropagation(); } },true);
    drawer.querySelector('[data-tracker-edge]').addEventListener('click',close);
    drawer.querySelector('.tracker-drawer__header form').addEventListener('submit',event => { event.preventDefault(); close(); });
    drawer.addEventListener('cancel',event => { event.preventDefault(); close(); });
    drawer.addEventListener('click',event => {
      if (event.target !== drawer) return;
      const r = drawer.getBoundingClientRect();
      if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) close();
    });
    drawer.addEventListener('close', () => {
      closing = false;
      drawer.classList.remove('is-opening','is-closing');
      clearGesture();
      document.documentElement.classList.remove('tracker-drawer-open');
      sequence += 1;
      window.clearTimeout(timer);
      resetResults();
      input.value = '';
      verify.querySelector('input').value = '';
      announce(copy('messageReady'));
      const target = canReceiveFocus(opener)
        ? opener
        : [...document.querySelectorAll('.tracker-shortcut,[data-menu-toggle]')].find(canReceiveFocus);
      target?.focus({ preventScroll: true });
    });
    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) refresh();
    });
    if (window.location.hash === '#OrderTrackerDrawer') open();
  })();

  } catch(e) { console.error(e); }
})();
})();
